// src/app/services/[service]/components/cloud/CloudPlatforms.jsx
"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import ScrollStack, { ScrollStackItem } from "./ScrollStack";
import styles from "./CloudPlatforms.module.css";
import { cloudPlatformCards } from "../../data/cloud-solutions";

export default function CloudPlatforms() {
  return (
    <section className={`${styles.section} py-5`}>
      <div className="container">
        <header className={styles.head} data-reveal="fade">
          <div className={styles.eyebrow}>CLOUD PLATFORMS</div>
          <h2 className={styles.title}>
            Our Expertise Across Leading Cloud Platforms
          </h2>
          <p className={styles.subtitle}>
            We empower businesses to solve their most critical challenges by
            leveraging our expertise with top cloud technologies, including AWS,
            Google Cloud, and Microsoft Azure.
          </p>
        </header>

        {/* ScrollStack of wide cards: half image + half text */}
        <ScrollStack
          className={styles.stackCenter}
          itemDistance={100}
          itemScale={0}
          itemStackDistance={36}
          stackPosition="50%"
          scaleEndPosition="12%"
          baseScale={1}
          rotationAmount={0}
          blurAmount={0}
          useWindowScroll
        >
          {cloudPlatformCards.map((c, i) => (
            <ScrollStackItem key={c.title} itemClassName={styles.wideCard}>
              <div className={styles.wideInner}>
                {i % 2 === 0 ? (
                  <>
                    <div className={styles.wideImgCol}>
                      <Image
                        src={c.image}
                        alt={c.title}
                        fill
                        className={styles.wideImg}
                        sizes="(max-width: 991px) 100vw, 490px"
                      />
                    </div>
                    <div className={styles.wideTextCol}>
                      <div className={styles.titleRow}>
                        <span className={styles.bar}></span>
                        <h3 className={styles.ctitle}>{c.title}</h3>
                      </div>
                      <p className={styles.desc}>{c.body}</p>
                      <Link
                        href="/contact"
                        className={`${styles.btn} ${styles.btnSm}`}
                        aria-label={`Cloud Consult - ${c.title}`}
                      >
                        <span>Cloud Consult</span>
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{ marginLeft: 8 }}
                        />
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.wideTextCol}>
                      <div className={styles.titleRow}>
                        <span className={styles.bar}></span>
                        <h3 className={styles.ctitle}>{c.title}</h3>
                      </div>
                      <p className={styles.desc}>{c.body}</p>
                      <Link
                        href="/contact"
                        className={`${styles.btn} ${styles.btnSm}`}
                        aria-label={`Cloud Consult - ${c.title}`}
                      >
                        <span>Cloud Consult</span>
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{ marginLeft: 8 }}
                        />
                      </Link>
                    </div>
                    <div className={styles.wideImgCol}>
                      <Image
                        src={c.image}
                        alt={c.title}
                        fill
                        className={styles.wideImg}
                        sizes="(max-width: 991px) 100vw, 490px"
                      />
                    </div>
                  </>
                )}
              </div>
            </ScrollStackItem>
          ))}
        </ScrollStack>
      </div>
    </section>
  );
}
